import React from "react";
import "./ServicesHero.css";
import { Link } from "react-router-dom";

const ServicesHero = () => {
  return (
    <section className="services-hero">
      <div className="sh-container">
        <h1 className="sh-title">
          Comprehensive Facility Management for Modern Businesses
        </h1>

        <p className="sh-subtext">
          We provide efficient, scalable, and modern facility management solutions
          tailored for corporate and industrial environments.
        </p>

        <p className="sh-breadcrumb">
          <Link to="/" className="sh-breadcrumb-link">Home</Link>
          <span> - </span>
          <Link to="/services" className="sh-breadcrumb-link">Our Services</Link>
        </p>
      </div>
    </section>
  );
};

export default ServicesHero;
